import * as React from 'react';
import { styled } from '@glitz/react';

export const Bubble = styled<React.PropsWithChildren>(props => {
  return (
    <Base suppressHydrationWarning>
      <Thing viewBox="0 0 20 25">
        <path d="M20 0v25H0L20 0z" />
      </Thing>
      {props.children}
    </Base>
  );
});

const Base = styled.div({
  position: 'relative',
  marginTop: 25,
  padding: { xy: t => t.sharedSpacing.m },
  backgroundColor: t => t.bubble.backgroundColor,
  color: t => t.bubble.color,
});

const Thing = styled.svg({
  position: 'absolute',
  bottom: '99%',
  right: '1.6rem',
  width: 20,
  height: 25,
  fill: t => t.bubble.backgroundColor,
});
